import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { DatepickerModule } from '@rappi/ui/datepicker';

import { DeleteBoxComponent } from './delete-box/delete-box.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { DateRangeComponent } from './date-range/date-range.component';

@NgModule({
  declarations: [DeleteBoxComponent, ConfirmDialogComponent, DateRangeComponent],
  imports: [CommonModule, MatDialogModule, ReactiveFormsModule, DatepickerModule],
  exports: [DeleteBoxComponent, ConfirmDialogComponent, DateRangeComponent]
})
export class ComponentLibraryModule {}
